import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

export const OdooSyncPage = lazy(
  () =>
    retry(
      () => import('@pages/settings/integrations/odoo-sync')
    ) as Promise<typeof import('@pages/settings/integrations/odoo-sync')>
);
